import axios from './util/axios'

export function getSignUpStyleColors () {
  return axios.get('/api/stylecolors/style_quiz/')
}
